// This file is generated by assets/update.ts - DO NOT EDIT MANUALLY
// Run 'bun assets/update.ts' to regenerate this file
// Last generated: 2025-11-06T15:28:19.836Z

import type { FiletypeParserOptions } from "./types"
import { resolve, dirname } from "path"
import { fileURLToPath } from "url"

import javascript_highlights from "./assets/javascript/highlights.scm" with { type: "file" }
import javascript_language from "./assets/javascript/tree-sitter-javascript.wasm" with { type: "file" }
import typescript_highlights from "./assets/typescript/highlights.scm" with { type: "file" }
import typescript_language from "./assets/typescript/tree-sitter-typescript.wasm" with { type: "file" }
import markdown_highlights from "./assets/markdown/highlights.scm" with { type: "file" }
import markdown_language from "./assets/markdown/tree-sitter-markdown.wasm" with { type: "file" }
import markdown_injections from "./assets/markdown/injections.scm" with { type: "file" }
import markdown_inline_highlights from "./assets/markdown_inline/highlights.scm" with { type: "file" }
import markdown_inline_language from "./assets/markdown_inline/tree-sitter-markdown_inline.wasm" with { type: "file" }
import zig_highlights from "./assets/zig/highlights.scm" with { type: "file" }
import zig_language from "./assets/zig/tree-sitter-zig.wasm" with { type: "file" }

// Cached parsers to avoid re-resolving paths on every call
let _cachedParsers: FiletypeParserOptions[] | undefined

export function getParsers(): FiletypeParserOptions[] {
  if (!_cachedParsers) {
    _cachedParsers = [
      {
        filetype: "javascript",
        queries: {
          highlights: [resolve(dirname(fileURLToPath(import.meta.url)), javascript_highlights)],
        },
        wasm: resolve(dirname(fileURLToPath(import.meta.url)), javascript_language),
      },
      {
        filetype: "typescript",
        queries: {
          highlights: [resolve(dirname(fileURLToPath(import.meta.url)), typescript_highlights)],
        },
        wasm: resolve(dirname(fileURLToPath(import.meta.url)), typescript_language),
      },
      {
        filetype: "markdown",
        queries: {
          highlights: [resolve(dirname(fileURLToPath(import.meta.url)), markdown_highlights)],
          injections: [resolve(dirname(fileURLToPath(import.meta.url)), markdown_injections)],
        },
        wasm: resolve(dirname(fileURLToPath(import.meta.url)), markdown_language),
        injectionMapping: {
          "nodeTypes": {
                    "inline": "markdown_inline",
                    "pipe_table_cell": "markdown_inline"
          },
          "infoStringMap": {
                    "javascript": "javascript",
                    "js": "javascript",
                    "typescript": "typescript",
                    "ts": "typescript",
                    "markdown": "markdown",
                    "md": "markdown"
          }
},
      },
      {
        filetype: "markdown_inline",
        queries: {
          highlights: [resolve(dirname(fileURLToPath(import.meta.url)), markdown_inline_highlights)],
        },
        wasm: resolve(dirname(fileURLToPath(import.meta.url)), markdown_inline_language),
      },
      {
        filetype: "zig",
        queries: {
          highlights: [resolve(dirname(fileURLToPath(import.meta.url)), zig_highlights)],
        },
        wasm: resolve(dirname(fileURLToPath(import.meta.url)), zig_language),
      },
    ]
  }
  return _cachedParsers
}
